import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { LogService } from './log.service';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  id:number;
  parent_id:number;
  name:string;
  url = "https://niivsnes.humge.com";
  constructor(private http:HttpClient,private logService:LogService) {
   }

  getProducts():Observable<any>{
    return this.http.get(this.url+'/api/product?token='+localStorage.getItem('token'));
  }
  deleteProduct(id):Observable<any>{
    this.logService.log("Изтриване на продукт "+id).subscribe();
    return this.http.delete(this.url+'/api/product/'+id+'?token='+localStorage.getItem('token'));
  }
  saveProduct(product):Observable<any>{
    this.logService.log("Добавяне на продукт ").subscribe();
    return this.http.post(this.url+'/api/product?token='+localStorage.getItem('token'),product);
  }
  editProduct(id):Observable<any>{
    return this.http.get(this.url+'/api/product/'+id+'/edit?token='+localStorage.getItem('token'));
  }
  updateProduct(product,id):Observable<any>{
    this.logService.log("Промяна на продукт "+id).subscribe();
    return this.http.put(this.url+'/api/product/'+id+'?token='+localStorage.getItem('token'),product);
  }

  getSubProducts(id):Observable<any>{
    return this.http.get(this.url+'/api/subProduct/'+id+'?token='+localStorage.getItem('token'));
  }
  getParentProds(id):Observable<any>{
    return this.http.get(this.url+'/api/parentProds/'+id+'?token='+localStorage.getItem('token'));
  }

  getAllProducts():Observable<any>{
    return this.http.get(this.url+'/api/getAllProducts?token='+localStorage.getItem('token'));
  }
  getIndicators(id){
    return this.http.get(this.url+'/api/getIndicators/'+id+'?token='+localStorage.getItem('token'));
  }

  setid(id){ 
    this.id= id;
  }
  getid():number{
    return this.id;
  }
  setparent_id(parent_id){ 
    this.parent_id= parent_id;
  }
  getparent_id():number{
    return this.parent_id;
  }

  setname(name){ 
    this.name= name;
  }
  getname():string{
    return this.name;
  }
}
